import { buildService } from './decorated-service';

const apigeeCookie = buildService('common-login-public/service');

export const callApigeeCookie = async (token: string): Promise<any> => {
  try {
    await apigeeCookie.http.post(
      'auth/cookie',
      { transferId: token },
      { transformResponse: (resp): Promise<any> => resp }
    );
  } catch (err) {
    /* eslint-disable no-console */
    console.warn('an error occurred while calling common login cookie');
    console.error(err);
    /* eslint-enable no-console */
  }
};
